import {
  NoAdsResultIconDark,
  NoAdsResultIconLight
} from '@/components/ui/Icons/Icons';
import { Typography } from '@/components/ui/Typography/Typography.styles';

import * as S from '../NoAds.styles';
import { Props } from '../NoAds.types';

export const NoAdsResult: Props = ({ t, isDark }) => {
  const icon = isDark ? <NoAdsResultIconLight /> : <NoAdsResultIconDark />;

  return (
    <S.NoAdsWrapper $paddingTop="80px" data-testid="no-ads-result">
      {icon}
      <S.TextWrapper $marginBottom="60px">
        <Typography variant="h0">{t('NoAds.result.title')}</Typography>
        <Typography variant="body2">{t('NoAds.result.subtitle')}</Typography>
      </S.TextWrapper>
    </S.NoAdsWrapper>
  );
};
